import { Currency } from '../types/account';

export default function buildDuemintPaymentUrl(
  collectionUrl: string | null,
  loanCurrency?: Currency,
): string | null {
  if (!collectionUrl) {
    return null;
  }
  const base = collectionUrl.split('?')[0];
  const query = collectionUrl.split('?')[1];

  if (!loanCurrency) {
    return `${base}/confirmPayment?${query}`;
  }
  return `${base}/confirmPayment?currency=${loanCurrency.abbreviation}&${query}`;
}
